export default {
  zIndex: 30,
}
